(() => {
  const priceSelector = '.price, .money, .totals__total-value, .cart-item__price-wrapper, .cart-item__totals, .cart-notification__subtotal, [data-product-price], [data-cart-total]';
  const cleanText = (node) => {
    if (!/\bUSD\b/.test(node.data)) return;
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, textarea, input, select, [contenteditable="true"]')) return;
    // Keep currency selectors and ordinary prose intact; only clean dollar prices.
    if (!/\$\s*[\d,.]+/.test(node.data) && !parent.closest(priceSelector)?.textContent.match(/\$\s*[\d,.]+/)) return;
    const cleaned = node.data.replace(/\s*\bUSD\b/g, '');
    if (cleaned !== node.data) node.data = cleaned;
  };
  const clean = (root) => {
    if (root.nodeType === Node.TEXT_NODE) return cleanText(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) cleanText(walker.currentNode);
  };
  const start = () => {
    clean(document.body);
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') cleanText(record.target);
        else record.addedNodes.forEach(clean);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
